<button mat-button class="pill" [class.selected]="selected" [class.clickable]="editable" (click)="togglePill()">
  {{ value }}
</button>
